import React from 'react';

const TestPage = () => {
  return (
    <div style={{ padding: '20px', color: 'red', fontSize: '20px' }}>
      <h1>TEST PAGE WORKING</h1>
      <p>If you can see this, React components are working.</p>
      <p>Current URL: {window.location.href}</p>
      <p>Time: {new Date().toLocaleTimeString()}</p>
    </div>
  );
};

export default TestPage;